import { SetStateAction, useState } from 'react';
import { OTP_LENGTH } from '../../../constants/form';

export const useOtp = () => {
  const [otpInput, setOtpInput] = useState<string | undefined>();
  const [showError, setShowError] = useState<boolean>(false);

  function validate(): boolean {
    if (otpInput?.length !== OTP_LENGTH) {
      setShowError(true);
      return false;
    }
    return true;
  }
  function reset() {
    setShowError(false);
    setOtpInput(undefined);
  }

  function setData(data: SetStateAction<string | undefined>) {
    setShowError(false);
    setOtpInput(data);
  }

  return [otpInput, setData, validate, reset, showError] as const;
};
